<template>
  <v-app>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-toolbar>
          <v-icon>cloud</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;Bandeja de Consultas Externas</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                textB1681
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)">
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-layout row>
            <v-flex xs12 sm6 md3 lg3>
              <v-autocomplete
                v-model="filtro.sucursalId"
                :items="sucursales"
                item-text="nombre"
                item-value="id"
                label="Solicitudes de la Sucursal:"
                placeholder="Seleccione una"
                :menu-props="{ minWidth: '400' }"></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md1 lg1 fluid v-if="muestraFiltroCanalesVenta">
              <v-checkbox
                v-model="cargaCanalesVenta"
                label="Filtrar Canales"
                :disabled="loading"
                @click="cargarCanalesVenta"></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3 v-if="cargaCanalesVenta">
              <v-autocomplete
                v-model="filtro.canalVentaId"
                :items="canalesVenta"
                item-text="nombre"
                item-value="id"
                multiple
                label="Originadas en:"
                placeholder="Seleccione un Canal de Venta"
                :menu-props="{ minWidth: '400' }"></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md3 l3>
              <v-autocomplete
                v-model="filtro.productoId"
                :items="productos"
                item-text="descripcion"
                item-value="id"
                label="Del producto:"
                placeholder="Seleccione uno"
                :menu-props="{ minWidth: '400' }"></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3>
              <app-selector-periodos
                v-on:update-periodo="
                  filtro.periodo = $event
                "></app-selector-periodos>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 md3 lg3>
              <v-text-field
                v-model="filtro.documento"
                label="Buscar por documento">
              </v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3>
              <v-select
                label="Analista:"
                v-model="filtro.analistaLogin"
                :items="analistas"
                item-text="login"
                item-value="login"></v-select>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3>
              <v-select
                label="En estados:"
                v-model="filtro.subEstadoId"
                :items="subestados"
                item-text="descripcion"
                item-value="id"></v-select>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3 fluid>
              <v-select
                label="Origen:"
                v-model="filtro.tipoCanalVentaId"
                :items="tiposCanalVenta"
                item-text="descripcion"
                item-value="id"></v-select>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-spacer></v-spacer>
            <v-flex xs12 sm6 md3 lg3 fluid>
              <v-btn
                color="success"
                @click="getItems(true)"
                :disabled="deshabilitarConsultar"
                >Consultar</v-btn
              >
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex>
              <v-card>
                <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Lista</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                  dense
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :rows-per-page="pagination.rowsPerPage"
                  :options.sync="pagination"
                  v-model="selectedRow"
                  :loading="loading"
                  class="elevation-1"
                  :footer-props="footer">
                  <template v-slot:no-data>
                    <v-alert
                      v-if="!primeraBusquedaRealizada"
                      :value="true"
                      color="grey lighten-3"
                      icon="info">
                      Ingrese los filtros para realizar la búsqueda
                    </v-alert>
                    <v-alert v-else :value="true" color="grey" icon="warning">
                      No se encontraron registros con los filtros ingresados
                    </v-alert>
                  </template>

                  <template v-slot:item="{ item }">
                    <tr>
                      <!-- <td>
                        <app-acciones-comunes
                          v-if="item"
                          :documento="item.documento"
                          :solicitudId="item.id"
                          :ocultarAnalisisCredito="true"
                          :showCompletarDocumentacion="true"
                          :showCancelarAnalisis="true"
                          @refrescar-lista="getItems(false)">
                        </app-acciones-comunes>
                      </td> -->

                      <td class="text-xs-left caption">
                        <tr>
                          {{
                            item.fecha
                          }}
                        </tr>
                      </td>

                      <td class="text-xs-left caption">
                        <tr class="text-xs-left font-weight-light caption">
                          {{
                            item.estado
                          }}
                        </tr>
                      </td>

                      <td class="text-xs-left caption">
                        <tr>
                          {{
                            item.nombre
                          }}
                        </tr>
                      </td>
                      <td class="text-xs-left caption">
                        <tr>
                          {{
                            item.cuil
                          }}
                        </tr>
                      </td>

                      <td class="text-xs-left caption">
                        {{ item.maximoCapital }}
                      </td>

                      <td class="text-xs-left caption">
                        {{ item.maximoCuota }}
                      </td>

                      <td class="text-xs-left caption">
                        {{ item.canalVenta }}
                      </td>

                      <td class="text-xs-left caption">
                        {{ item.producto }}
                      </td>
                      <td class="text-xs-left caption">
                        {{ item.respuestaMotor }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-card-actions>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="3">
                        <v-btn
                          color="info"
                          v-if="records.length > 0"
                          :disabled="loading"
                          @click="imprimirListado"
                          >Imprimir Listado</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>

          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="success" @click="procesarReporte" >Generar Reporte</v-btn> -->
          </v-card-actions>
          <template v-if="$store.state.debugModeOn">
            Debug Info:
            <p></p>

            Model: {{ filtro }}
            <p></p>
          </template>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>

      <!-- variables motor -->
      <!-- <v-dialog v-model="showVariablesMotor" width="1200">
        <app-variables-motor
          :ConsultaMotorId="ejecucionMotorId"></app-variables-motor>
      </v-dialog> -->
    </v-container>
  </v-app>
</template>

<script>
import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      editMode: false,
      suspend: false,
      filterChanged: false,
      search: "", // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 20, 50],
      },
      totalItems: 0, // va afuera de pagination
      headers: [],
      records: [], // registros
      selectedRow: [],
      filtro: {
        sucursalId: 0,
        canalVentaId: 0,
        productoId: 0,
        subEstadoId: 0,
        tipoCanalVentaId: 0,
        analistaLogin: "(Todos)",
        periodo: { id: 1 },
        filtrarUltimaActualizacion: false,
        filtrarRechazoPorMora: false,
        periodoActualizacion: { id: 1 },
      },
      canalesVenta: [],
      sucursales: [],
      productos: [],
      subestados: [],
      analistas: [],
      tiposCanalVenta: [],
      showVariablesMotor: false,
      ejecucionMotorId: 0,
      cargaCanalesVenta: false,
      muestraFiltroCanalesVenta: true,
    };
  },
  async created() {
    // definición de columnas
    /*
        Fecha
        Estado
        Nombre
        Documento
        MaximoCapital	
        MaximoCuota	
        CanalVenta
        Producto
    */

    // this.headers.push({
    //   text: "Acciones",
    //   value: "accion",
    //   width: 80,
    //   sortable: false,
    // });
    this.headers.push({
      text: "Fecha de Ingreso",
      value: "fecha"
    });
    this.headers.push({ text: "Estado", value: "estado" });
    this.headers.push({ text: "Nombre", value: "nombre" });
    this.headers.push({ text: "Cuil", value: "cuil" });

    // if (
    //   this.$store.state.parametrosGenerales.ingresoPorDefectoPor == "documento"
    // )
    //   this.headers.push({ text: "Documento", value: "documento" });
    // else this.headers.push({ text: "Cuil", value: "cuil" });

    // this.headers.push({ text: "Solicitante", value: "solicitante" });
    // this.headers.push({
    //   text: "Alta por",
    //   value: "usuarioAlta",
    //   sortable: false,
    // });
    this.headers.push({ text: "Máximo Capital", value: "maximoCapital" });
    this.headers.push({
      text: "Máximo Cuota",
      value: "maximoCuota",
      width: 120,
    });
    // this.headers.push({
    //   text: "Fecha de Ingreso",
    //   value: "fechaIngreso",
    //   width: 120,
    // });
    // this.headers.push({
    //   text: "Es Cliente",
    //   value: "esCliente",
    //   sortable: false,
    // });

    // if (!this.user.esComercio)
    //   this.headers.push({
    //     text: "Pasó por Motor",
    //     value: "motorSiisa",
    //     sortable: false,
    //   });

    this.headers.push({
      text: "Canal de Venta",
      value: "canalventa"
    });
    this.headers.push({ text: "Producto", value: "producto"});
    this.headers.push({ text: "Rta.Motor", value: "respuestaMotor" });

    this.loadSucursales();
    if(!this.$store.state.user.accesoTodosCanalesVenta)
      this.cargarCanalesVenta();
    else
      this.canalesVenta.push("(Todos)");
    
    this.loadProductos();
    this.loadSubEstados();
    this.loadAnalistas();
    this.loadTiposCanalVenta();
  },
  watch: {
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems(false);
      },
      deep: true,
    },
    search() {
      this.getItems(true);
    },
  },
  computed: {
    ...mapGetters([
      "checkCanCreate",
      "checkCanUpdate",
      "checkCanDelete",
      "checkCanAccess",
      "getActionFromLink",
      "error",
      "user",
    ]),
    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    deshabilitarConsultar: function () {
      return (
        this.loading || !this.canalesVenta || this.canalesVenta.length == 0
      );
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente", "cancelarAnalisis"]),
    puedeRetomar(item) {
      return (
        item.subEstado == "Cupo Aprobado" ||
        item.subEstado == "Cupo Modificado" ||
        item.subEstado == "Consulta Pendiente"
      );
    },
    async cargarCanalesVenta() {
      this.loadCanalesVenta();
      this.canalesVenta.push("(Todos)");
      this.muestraFiltroCanalesVenta = false;
      this.cargaCanalesVenta = true;
    },
    async getItems(resetPagination) {
      if (this.filtro.periodo.desde === undefined) {
        this.alertWarning("Debe elegir un periodo para la búsqueda.");
        return;
      }

      // if (!this.canalesVenta || this.canalesVenta.length == 0) {
      //   this.alertWarning(
      //     "Por favor, espere a que las listas terminen de cargarse antes de realizar la consulta."
      //   );
      //   return;
      // }

      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;

      let idCanalesVenta = filter.canalVentaId.toString();

      //Si se eligió TODOS ( y no tiene acceso a todos los canales) armo un string con todos los canales de venta habilitados para el usuario.
      if (
        filter.canalVentaId === 0 &&
        !this.$store.state.user.accesoTodosCanalesVenta
      ) {
        for (var i = 0; i < this.canalesVenta.length; i++) {
          if (i === 0) idCanalesVenta = this.canalesVenta[i].id;
          else idCanalesVenta += "," + this.canalesVenta[i].id;
        }
      } else {
        idCanalesVenta = filter.canalVentaId;
      }

      //Para que a los usuarios que no son comer no les traiga los casos marcados con documentacion pendiente
      //  const incluirConDocumentacionPendiente = this.user.esComer;

      //Si el usuario no es concentrador solo permite ver las consultas que dio de alta
      // const loginUsuarioAlta = this.user.esConcentrador
      //   ? "(Todos)"
      //   : this.user.login;

      try {
        var result = await http.get(
          "ConsultasExternas/listconsultasexternas?canalesVenta=" +
            idCanalesVenta +
            "&productoId=" +
            filter.productoId +
            "&estadoId=" +
            filter.subEstadoId +
            "&tipoCanalVentaId=" +
            filter.tipoCanalVentaId +
            "&documento=" +
            filter.documento +
            "&fechaDesde=" +
            filter.periodo.desde +
            "&fechaHasta=" +
            filter.periodo.hasta +
            "&limit=" +
            this.pagination.itemsPerPage +
            "&page=" +
            this.pagination.page +
            "&sortby=" +
            this.pagination.sortBy +
            "&descending=" +
            (this.pagination.sortDesc.length > 0
              ? this.pagination.sortDesc
              : "false")
        );

        Vue.$log.debug(result);
        this.records = result;
        if(result.length> 0)
          this.totalItems = result[0].totalFilas;
        else
          this.totalItems = 0;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;
    },
    async finAnalisis() {},

    async resetState() {
      this.$validator.reset();
      this.editMode = false;
    },
    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get("productos/");

        this.productos = result.list;

        this.productos.unshift({ id: 0, descripcion: "(Todos)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          "sucursales/list/porusuario?usuarioId=" + this.user.id
        );

        this.sucursales = result.list;

        this.sucursales.unshift({ id: 0, nombre: "(Todas)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          "canalesventa/habilitadosparausuario?usuarioId=" + this.user.id
        );

        this.canalesVenta = result.list;

        //   this.canalesVenta.unshift({ id: 0, nombre: '(Todos)' });
        // } catch (error) {
        //   // Error
        //   this.alertError(error);
        // }
        // this.loading = false;
        this.canalesVenta.unshift({ id: 0, nombre: "(Todos)" });

        this.toggleCanalesVenta();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    toggleCanalesVenta() {
      this.$nextTick(() => {
        if (this.todosLosCanalesVentaMarcados) {
          this.filtro.canalesVenta = [];
        } else {
          this.filtro.canalesVenta = this.canalesVenta.map(function (p) {
            return p.id;
          });
        }
      });
    },
    async loadSubEstados() {
      this.loading = true;
      try {
        var result = await http.get(
          "tipossubestadocredito?estadosParaAnalisisConsulta=true"
        );

        this.subestados = result.list;

        this.subestados.unshift({ id: 0, descripcion: "(Todos)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadAnalistas() {
      this.loading = true;
      try {
        var result = await http.get("usuarios/listByRol?rolId=3"); //traigo los usuarios con rol analista

        this.analistas = result.list;

        this.analistas.unshift({
          id: "00000000-0000-0000-0000-000000000000",
          login: "(Todos)",
        });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadTiposCanalVenta() {
      this.loading = true;
      try {
        var result = await http.get("tiposcanalventa");
        this.tiposCanalVenta = result.list;
        this.tiposCanalVenta.unshift({ id: 0, descripcion: "(Todos)" });
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    imprimirListado() {
      let filter = this.filtro;

      let idCanalesVenta = filter.canalVentaId.toString();

      //Si se eligió TODOS ( y no tiene acceso a todos los canaes) armo un string con todos los canales de venta habilitados para el usuario.
      if (
        filter.canalVentaId === 0 &&
        !this.$store.state.user.accesoTodosCanalesVenta
      ) {
        for (var i = 0; i < this.canalesVenta.length; i++) {
          if (i === 0) idCanalesVenta = this.canalesVenta[i].id;
          else idCanalesVenta += "," + this.canalesVenta[i].id;
        }
      } else {
        idCanalesVenta = filter.canalVentaId;
      }

      // const loginUsuarioAlta = this.user.esConcentrador ? "" : this.user.login;
      // const loginAnalista =
      //   filter.analistaLogin == "(Todos)" ? "" : filter.analistaLogin;

      let params = [];
      params.push({
        /*
        @CanalesVenta VARCHAR(8000),
        @ProductoId INT,
        @TipoCanalVentaId INT,
        @EstadoId VARCHAR(255),
        @IngresoDesde SMALLDATETIME,
        @IngresoHasta SMALLDATETIME,
        @Documento VARCHAR(8),
        @NoFiltrarEstado BIT,
        @Take INT,
        @Offset INT,
        @SortColumn VARCHAR(20) = 'Fecha', --Valores por defecto
        @SortOrder VARCHAR(4) = 'ASC'
    */

        CanalesVenta: idCanalesVenta, // CanalesVenta
        ProductoId: filter.productoId, // ProductoId
        TipoCanalVentaId: filter.tipoCanalVentaId,
        IngresoDesde: filter.periodo.desde, // IngresoDesde
        IngresoHasta: filter.periodo.hasta, // IngresoHasta
        EstadoId: filter.subEstadoId,
        Documento: filter.documento,
        NoFiltrarEstado: true,
        Take: 9999,
        Offset: 0,
        SortColumn: "Fecha",
        SortOrder: "ASC",
        // CanalVenta: this.canalesVenta.find(
        //   (i) => i.id == this.filtro.canalVentaId
        // ).nombre,
        //FiltrarRechazoPorMora: filter.filtrarRechazoPorMora,
      });

      this.setReporteActivo({
        reporte: "Listado de Consultas Externas.trdp",
        params: params,
      });

      window.open("/report-viewer");
    },
  },
};
</script>
